export enum OpenFundRequestStatus {
  Incomplete = 'Incomplete',
  PendingApproval = 'PendingApproval',
  DeletedByOffice = 'DeletedByOffice',
  CancelledByUser = 'CancelledByUser',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Completed = 'Completed',
  ReturnedFromIncomplete = 'ReturnedFromIncomplete',
}
